export class Country {
  name: string;
  zone: Zone;
  iso_a2: string | null;

  constructor(data: { name: string; zone: Zone; isO_A2: string | null }) {
    this.name = data.name;
    this.zone = data.zone;
    this.iso_a2 = data.isO_A2;
  }
}

export enum Zone {
  unitedKingdom = 1,
  europe = 2,
  restOfWorld = 3,
  usa = 4,
  collection = 5,
  denmark = 6,
  eu = 7
}